/* eslint-disable brace-style */
import Config from 'es6/core/config';

/**
 * Something important to note about this class is that it does check
 * the config settings for language dependencies.
 */
export default class Transliterable {
  /**
   * Expects the following attributes:
   *    - language
   *    - text
   *    - transliterations
   */
  constructor(attrs = {}) {
    _.defaults(this, attrs);
  }

  /**
   * Returns a two character code for the language
   *
   * @param {Transliterable} transliterable
   * @returns {String}
   */
  getLanguageShortCode() {
    return this.language && this.language.substr(0, 2);
  }

  /**
   * Returns the appropriate transliteration for sorting Transliterables.
   *
   * @returns {String}
   */
  getSortableText() {
    const language = this.getLanguageShortCode();

    if (language === 'ja' && this.transliterations.Hira) {
      return this.transliterations.Hira;
    } else if (language === 'zh' && this.transliterations.Latn) {
      return this.transliterations.Latn;
    } else {
      return this.text;
    }
  }

  /**
   * Gets the appropriate text for a word based on the app configuration.
   *
   * @returns {String}
   */
  getText() {
    const transliterations = this.transliterations;

    if (this.getLanguageShortCode() === 'ja') {
      if (Config.langSettings.romajiMode) {
        return transliterations.Latn;
      } else if (Config.langSettings.kanaMode) {
        return transliterations.Hrkt;
      }
    }

    return this.text;
  }

  /**
   * Gets the appropriate transliteration for a word based on the app
   * configuration.
   *
   * @returns {String}
   */
  getTransliteration() {
    const lang = this.getLanguageShortCode();
    const transliterations = this.transliterations;

    if (lang === 'zh') {
      return transliterations.Latn;
    } else if (lang === 'ja') {
      if (Config.langSettings.kanaMode) {
        return transliterations.Latn;
      }

      // If it is not romaji mode, default to hiragana/katakana.
      // If this is a hiragana or katakana word, only return it if
      // it does not match the text.
      else if (!Config.langSettings.romajiMode && transliterations.Hrkt !== this.text) {
        return transliterations.Hrkt;
      }
    }

    return null;
  }
}
